import { useQuery } from '@tanstack/vue-query'
import { useHttp } from '@/shared/lib'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

/**
 * Функция загрузки шапки для шкафов
 */
const useLoadCabinet = (cabinet_id?: number) => {
  const http = useHttp()
  const route = useRoute()

  const url = computed(() => `/cabinets/${cabinet_id || route.params.object_id}`)

  const queryKey = computed(() => ['load_cabinet', cabinet_id || route.params.object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}

export { useLoadCabinet }
